import { useKeycloak } from '@react-keycloak/web';

export const useIsTenantAdmin = () => {
  const { keycloak } = useKeycloak();
  const loggedInUser: any = keycloak.idToken && keycloak?.idTokenParsed;

  return (
    loggedInUser?.groups?.includes('tenant-admin') ||
    keycloak.hasResourceRole('super-admin') ||
    keycloak.hasResourceRole('tenant-admin')
  );
};
